import React from "react";
import PropTypes from "prop-types";
import { StaticImage } from "gatsby-plugin-image";
import GatsbyImage from "../gatsbyImage";
import generateRandomId from "../../helpers/generateRandomId";

import * as styles from "./style.module.scss";

const Speaker = ({ avatar, description, jobTitle, speakerName, cardColor }) => {
  return (
    <div
      className={styles.speakerItemWrapper}
      style={{ backgroundColor: cardColor }}
    >
      <div className={styles.speakerImgContainer}>
        <div className={styles.speakerBackgroundImg}>
          <StaticImage
            alt="DottedBackgroundImage"
            placeholder="blurred"
            src="../../../static/images/author_dotted_background.svg"
          />
        </div>
        <div className={styles.speakerAvatar}>
          <GatsbyImage
            alt={"speaker avatar" + generateRandomId()}
            height={177}
            width={177}
            img={avatar.asset}
          />
        </div>
      </div>
      <p
        style={{
          paddingBottom: "8px",
          fontFamily: "Raleway, Arial, sans-serif",
          fontWeight: 700,
          fontSize: "22px",
        }}
      >
        {speakerName}
      </p>
      <div className={styles.info}>
        {jobTitle && <span>{jobTitle}</span>}
        {description && (
          <span className={styles.description}>{description}</span>
        )}
      </div>
    </div>
  );
};

Speaker.propTypes = {
  avatar: PropTypes.object.isRequired,
  speakerName: PropTypes.string.isRequired,
  cardColor: PropTypes.string.isRequired,
  description: PropTypes.string,
  jobTitle: PropTypes.string,
};

Speaker.defaultProps = {
  description: "",
  jobTitle: "",
};

export default Speaker;
